import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { IUser } from '../../../ts/ServerApi/types/IUser';
import { INamedItem } from '../../../ts/ServerApi/types/resourceParts';
import { ILens } from '../types/ILens';

export interface IGetLensesParams extends IGetItemsParams {
}

export interface IGetLensesResult extends IGetItemsResult {
  lenses?: ILens[];
  users?: IUser[];
  projects?: INamedItem[];
  favorites?: string[];
}

export class GetLensesRequest extends Request<IGetLensesParams, IGetLensesResult> {
  constructor(params: IGetLensesParams) {
    super('getLenses', params);
  }
}
